export const nodeMap = {
    0: {
        type: 'info',
        text: '无节点',
    },
    1: {
        type: 'success',
        text: '小节点',
    },
    2: {
        type: 'warning',
        text: '大节点'
    },
    3: {
        type: 'danger',
        text: '超节点'
    }
}

export const turnoverRateMap = {
    1: 'success',
    2: 'warning',
    3: 'danger'
}

export const consecutiveBoardsMap = {
    1: '首板',
    2: '二板',
    3: '三板',
    4: '四板',
    5: '五板',
    6: '六板',
    7: '七板',
    8: '八板',
    9: '九板',
    10: '十板',
    11: '十一板',
    12: '十二板',
    13: '十三板',
    14: '十四板',
    15: '十五板',
    16: '十六板',
    17: '十七板',
    18: '十八板',
    19: '十九板',
    20: '二十板',
}